"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = exports.SmartBackground = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _knotchWebReactComponentsUtils = require("@bit/knotchinc.web-react-components.utils.styled-helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  z-index: 2;\n  ", ";\n  background: ", ";\n  opacity: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  background: ", ";\n  z-index: 0;\n  overflow: hidden;\n\n  .smartImage {\n    ", ";\n    z-index: 0;\n    background-size: cover;\n    background-position: center center;\n    transition: all .3s ease;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SmartBackground = _styledComponents["default"].div(_templateObject(), (0, _knotchWebReactComponentsUtils.absFull)(), function (_ref) {
  var background = _ref.background,
      showGradient = _ref.showGradient,
      theme = _ref.theme;

  if (showGradient) {
    return theme.colors.palette[1];
  }

  return background || '#273037';
}, (0, _knotchWebReactComponentsUtils.absFull)());

exports.SmartBackground = SmartBackground;

var Overlay = _styledComponents["default"].div(_templateObject2(), (0, _knotchWebReactComponentsUtils.absFull)(), function (_ref2) {
  var showGradient = _ref2.showGradient,
      theme = _ref2.theme;
  return showGradient ? "linear-gradient(26.38deg, ".concat(theme.colors.palette[0], " 31.3%, rgba(28, 28, 28, 0.78) 88.9%)") : '#1a2228';
}, function (_ref3) {
  var opacity = _ref3.opacity;
  return opacity;
});

exports.Overlay = Overlay;

//# sourceMappingURL=styled.js.map